import { Component, HostListener, Renderer, ViewChild } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { Keyboard } from '@ionic-native/keyboard';
import { AlertMessager } from "../../lib/alertMessager";
import { Observable } from "rxjs";
import { DataService } from "../../services/data";
import { Rodeo } from "../../model/rodeo";
import { RodeoEvent } from "../../model/rodeoEvent";
import { ThrowStmt } from "@angular/compiler";
import { BuddyRequest } from "../../model/buddy-request";
import { Account } from "../../model/account";

@Component({
    selector: 'buddy-entry',
    templateUrl: 'buddy-entry.html'
})
export class BuddyEntry {
    @ViewChild('userSearch') userSearch;

    searchTitle: string = "Member Search";
    searchChangeObservable;
    teammateSearchChangeObservable;
    selecting: boolean = false;
    
    results: any = [];
    staff: boolean = false;
    selectedBuddy: Account = null;

    teammateResults: any = [];
    selectedBuddyTeammate: Account;
    teammateHeader: boolean = false;
    showTeammate: boolean = false;

    buddyIdSearch: boolean;
    buddyTeammateIdSearch: boolean;

    rodeo: Rodeo;
    availableEventTypes: RodeoEvent[] = [];
    rodeoEvent: RodeoEvent;

    constructor(private _viewCtrl: ViewController,
        private navParams: NavParams,
        private data: DataService,
        private renderer: Renderer,
        private alert: AlertMessager,
        private keyboard: Keyboard) {
        this.rodeo = navParams.get('rodeo');
        this.rodeoEvent = navParams.get('rodeoEvent');
        this.showTeammate = this.rodeoEvent.eventType == 'TeamRoping';
        this.availableEventTypes = this.rodeo.rodeoEvents;
        this.searchTitle = this.navParams.get('searchTitle');
    }

    ionViewDidEnter() {
        const element = this.userSearch._elementRef.nativeElement.querySelector('input');
        // we need to delay our call in order to work with ionic ...
        setTimeout(() => {
            this.renderer.invokeElementMethod(element, 'focus', []);
            this.keyboard.show();
        }, 0);
    }

    onSearchChange(searchEvent, searchValue : string) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(300) // wait 300ms after the last event before emitting last event
              .distinctUntilChanged() // only emit if value is different from previous value
              .subscribe((searchValue) => { this.searchForAccount(searchEvent, searchValue) });
        }

		this.searchChangeObservable.next(searchValue);
    }

    onTeammateSearchChange(searchEvent, searchValue : string) {
        if (!this.teammateSearchChangeObservable) {
            Observable.create(observer => {
                this.teammateSearchChangeObservable = observer;
            }).debounceTime(300) // wait 300ms after the last event before emitting last event
              .distinctUntilChanged() // only emit if value is different from previous value
              .subscribe((searchValue) => { this.searchForTeammate(searchEvent, searchValue) });
        }

		this.teammateSearchChangeObservable.next(searchValue);
    }

	searchForAccount(searchEvent, searchValue : string) {
        this.buddyIdSearch = true;
        this.selectedBuddy = null;

        const search = searchValue.trim().toLocaleLowerCase();
        let firstName = search;
        let lastName = '';

        if (search.indexOf(' ') > 0) {
            firstName = search.split(' ')[0];
            lastName = search.split(' ')[1];
        }

        this.data.getStaffUserSearch(firstName, lastName, "")
        .then(data => {
            this.results = data;

            if (this.results.length <= 0) {
                this.selectedBuddy = null;
            }
        })
        .catch(error => this.alert.showError('Error', 'Unable to retrieve search results: ' + error));
	}

    toggleTeammateRole() {
        this.teammateHeader = !this.teammateHeader;
    }

	searchForTeammate(searchEvent, searchValue : string) {
        this.buddyTeammateIdSearch = true;
        this.selectedBuddyTeammate = null;

        const search = searchValue.trim().toLocaleLowerCase();
        let firstName = search;
        let lastName = '';

        if (search.indexOf(' ') > 0) {
            firstName = search.split(' ')[0];
            lastName = search.split(' ')[1];
        }

        this.data.getStaffUserSearch(firstName, lastName, "")
        .then(data => {
            this.teammateResults = data;

            if (this.results.length <= 0) {
                this.selectedBuddyTeammate = null;
            }
        })
        .catch(error => this.alert.showError('Error', 'Unable to retrieve search results: ' + error));
	}

    getSearchMessage(searchValue, results) {
        if (searchValue == undefined || searchValue.trim().length == 0)
            return "";
        else if (results == undefined || results.length < 1)
            return "There are no users by that member id.";

        return "";
    }

    updateEvents() {
        this.showTeammate = this.rodeoEvent.eventType == 'TeamRoping';

        if (!this.rodeoEvent.eventType.includes("TeamRoping"))
            this.teammateHeader = false;
    }
    
    selectItem(item) {
        this.selectedBuddy = item;
    }

    selectTeammate(item) {
        this.selectedBuddyTeammate = item;
    }

    save() {
        let buddyRequest = new BuddyRequest();
        buddyRequest.buddy = this.selectedBuddy;
        buddyRequest.rodeoEventId = this.rodeoEvent.id;
        buddyRequest.buddyTeammate = this.selectedBuddyTeammate;
        buddyRequest.teammateHeader = this.teammateHeader;

        return this._viewCtrl.dismiss({buddyRequest : buddyRequest}, 'backdrop');
    }

    cancel() {
        this._bdClick();
    }

    _bdClick() {
        return this._viewCtrl.dismiss({ buddies: null}, 'backdrop');
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 27 && this._viewCtrl.isLast()) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        } else if (ev.keyCode === 38 && this.results.length > 0) {
            if (this.results[0] !== this.selectedBuddy) {
                let index = this.results.indexOf(this.selectedBuddy);

                this.selectedBuddy = this.results[index - 1];                
            }
        } else if (ev.keyCode === 40 && this.results.length > 0) {
            if (this.results[this.results.length - 1] !== this.selectedBuddy) {
                let index = this.results.indexOf(this.selectedBuddy);

                this.selectedBuddy = this.results[index*1 + 1];                
            }
        } else if (ev.keyCode === 13 && this.selectedBuddy != null) {
            this.selectItem(this.selectedBuddy);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/buddy-entry/buddy-entry.ts